<script>
export default {
  name: "ConfirmAccount",
  created() {
    this.axios.put(this.$store.getters.getUrl('confirmEmail'), this.$route.params.token).then(() => {
      this.$store.dispatch('addNotification',
          {
            type: 'success',
            message: this.$t('success.activateEmailSuccessful')
          });
    }).finally(() => {
      this.$router.push({name: 'login'});
    });
  },
};
</script>
